import { render } from "./PaginationView.vue?vue&type=template&id=31a79ce8&scoped=true"
import script from "./PaginationView.vue?vue&type=script&lang=js"
export * from "./PaginationView.vue?vue&type=script&lang=js"

import "./PaginationView.vue?vue&type=style&index=0&id=31a79ce8&scoped=true&lang=css"

import exportComponent from "/Users/jeongyunl/Documents/GitHub/datamap-search/vue-for-django/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31a79ce8"]])

export default __exports__